module.exports = __webpack_public_path__ + "media/images/close-up-of-male-hands-typing-on-laptop-keyboard-76287444ffebea2bc3fab9b90628d18c.jpg";